<template>
    <div class="okraina-cp-br" v-if="visible" :style="style">{{ count }} баллов за отзыв</div>
</template>

<script>
export default {
    name: "okraina-catalog-product-bonus-review",
    components: {},
    data() {
        return {};
    },
    props: {
        item: {
            type: Object,
            default() {
                return null;
            },
        },
    },
    computed: {
        visible() {
            return (
                this.isEnabled && this.count > 0
            );
        },

        isEnabled() {
            if (!this.item.PROPS.BONUS_REVIEW_ENABLED) {
                return false;
            }
            return true;
        },

        count() {
            if (!this.item.PROPS.BONUS_REVIEW_COUNT) {
                return 0;
            }

            return this.item.PROPS.BONUS_REVIEW_COUNT;
        },

        style() {
            let style = {};
            if (this.item.PROPS.BONUS_REVIEW_TEXT_COLOR) {
                style.color = this.item.PROPS.BONUS_REVIEW_TEXT_COLOR;
            }
            if (this.item.PROPS.BONUS_REVIEW_BACK_COLOR) {
                style.background = this.item.PROPS.BONUS_REVIEW_BACK_COLOR;
            }

            return style;
        }

    },
}
</script>

<style lang="scss">
.okraina-cp-br {
    display: inline-block;
    border-radius: 13px;
    padding: 3px 5px;
    line-height: 1;
    font-size: 9px;
    text-align: center;

    background: var(--color-color6);
    color: var(--color-text-dark);
}
</style>